import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import GlobalStyle from './components/styles/GlobalStyle';

// Auth components
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import PasswordChange from './components/auth/PasswordChange';
import PrivateRoute from './components/auth/PrivateRoute';

// Layout components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Admin components
import AdminDashboard from './components/admin/Dashboard';
import ImageUpload from './components/admin/ImageUpload';
import RegistrationRequests from './components/admin/RegistrationRequests';

// Client components
import ClientDashboard from './components/client/Dashboard';

// Context
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <AuthProvider>
        <Router>
          <div className="app-container">
            <Header />
            <main className="main-content">
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/password-change" element={<PasswordChange />} />
                
                {/* Admin routes */}
                <Route path="/admin" element={
                  <PrivateRoute requiredRole="admin">
                    <AdminDashboard />
                  </PrivateRoute>
                } />

                <Route path="/admin/upload" element={
                  <PrivateRoute requiredRole="admin">
                    <ImageUpload />
                  </PrivateRoute>
                } />
                
                <Route path="/admin/registration-requests" element={
                  <PrivateRoute requiredRole="admin">
                    <RegistrationRequests />
                  </PrivateRoute>
                } />
                
                {/* Client routes */}
                <Route path="/client" element={
                  <PrivateRoute>
                    <ClientDashboard />
                  </PrivateRoute>
                } />
                
                {/* Default routes */}
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
